import { TFunction } from "i18next";

/**
 * Number of connected LinkedIn accounts granted per credit tier.
 * Mirrors the logic used in SelectSubscription.
 */
export const getConnectedAccountsCount = (credits: number): number => {
	if (credits === 2000) {
		return 2;
	}

	if (credits === 10000) {
		return 8;
	}

	return 4;
};

/** Checkout card titles per credit tier, keyed by credit volume. */
const TIER_LABEL_KEY_BY_CREDITS: Record<number, string> = {
	2000: "usage.subscription.checkout.tier.starter",
	5000: "usage.subscription.checkout.tier.advanced",
	10000: "usage.subscription.checkout.tier.scale",
};

/**
 * Translation key for a plan's tier name. Every Stripe product is named after
 * its billing interval ("Yearly Signalist subscription"), which reads the same
 * on all three cards — the credit volume is what actually distinguishes them.
 * Returns null for an off-ladder tier so callers can fall back to the Stripe name.
 */
export const getPlanTierLabelKey = (credits: number): string | null =>
	TIER_LABEL_KEY_BY_CREDITS[credits] ?? null;

/**
 * Derives the card feature list from a product's credit tier, since the
 * StripeProduct schema does not carry an explicit features array.
 */
export const getSubscriptionFeatures = (credits: number, t: TFunction): string[] => [
	t("usage.subscription.select.features.connectedLinkedinAccounts", {
		count: getConnectedAccountsCount(credits),
	}),
	t("usage.subscription.select.features.exportAllLists"),
	t("usage.subscription.select.features.oneTimeOrOngoing"),
	t("usage.subscription.select.features.aiResearchAgent"),
	t("usage.subscription.select.features.integrations"),
	credits === 10000
		? t("usage.subscription.select.features.dedicatedManager")
		: t("usage.subscription.select.features.standardSupport"),
];
